import { render } from "./index.vue?vue&type=template&id=da2e749a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=da2e749a&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da2e749a"],['__file',"src/vab/components/VabFold/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "da2e749a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('da2e749a', __exports__)) {
    console.log('reload')
    api.reload('da2e749a', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=da2e749a&scoped=true", () => {
    console.log('re-render')
    api.rerender('da2e749a', render)
  })

}


export default __exports__